"use strict";

var _interopRequireDefault = require("/root/workspace/mall_vue_JOYE/node_modules/@babel/runtime/helpers/interopRequireDefault.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.auditSecKillRefund = auditSecKillRefund;
exports.confirmSecKillRefund = confirmSecKillRefund;
exports.copySecKill = copySecKill;
exports.deleteSecKill = deleteSecKill;
exports.directSecKillRefund = directSecKillRefund;
exports.exportSecKillOrder = exportSecKillOrder;
exports.exportSecKillRefund = exportSecKillRefund;
exports.fullSecKillRefund = fullSecKillRefund;
exports.getBonusRuleList = getBonusRuleList;
exports.getCouponList = getCouponList;
exports.getSecKillDetail = getSecKillDetail;
exports.getSecKillList = getSecKillList;
exports.getSecKillOrderList = getSecKillOrderList;
exports.getSecKillRefundList = getSecKillRefundList;
exports.saveSecKill = saveSecKill;
exports.toggleSecKillStatus = toggleSecKillStatus;
exports.uploadSecKillImage = uploadSecKillImage;
var _requestAuth = _interopRequireDefault(require("@/utils/requestAuth"));
/**
 * 获取秒杀活动列表
 * @param {Object} query - 查询参数
 */
function getSecKillList(query) {
  return (0, _requestAuth.default)({
    url: '/secKill/list',
    method: 'get',
    params: query
  });
}

/**
 * 获取秒杀活动详情
 * @param {Number} id - 活动ID
 */
function getSecKillDetail(id) {
  return (0, _requestAuth.default)({
    url: "/secKill/".concat(id),
    method: 'get'
  });
}

/**
 * 保存秒杀活动（新增或更新）
 * @param {Object} data - 活动数据
 */
function saveSecKill(data) {
  return (0, _requestAuth.default)({
    url: '/secKill',
    method: 'post',
    data: data
  });
}

/**
 * 删除秒杀活动
 * @param {Number} id - 活动ID
 */
function deleteSecKill(id) {
  return (0, _requestAuth.default)({
    url: "/secKill/".concat(id),
    method: 'delete'
  });
}

/**
 * 启用/禁用秒杀活动
 * @param {Number} id - 活动ID
 * @param {Number} enabled - 状态值
 */
function toggleSecKillStatus(id, enabled) {
  return (0, _requestAuth.default)({
    url: "/secKill/toggleStatus/".concat(id),
    method: 'post',
    data: {
      enabled: enabled
    }
  });
}

/**
 * 上传秒杀图片
 * @param {File} file - 图片文件
 */
function uploadSecKillImage(file) {
  var formData = new FormData();
  formData.append('file', file);
  return (0, _requestAuth.default)({
    url: '/secKill/uploadImage',
    method: 'post',
    data: formData,
    headers: {
      'Content-Type': 'multipart/form-data'
    }
  });
}

/**
 * 获取优惠券列表（用于发放内容选择）
 * @param {Object} query - 查询参数
 */
function getCouponList(query) {
  return (0, _requestAuth.default)({
    url: '/coupon/list',
    method: 'get',
    params: query
  });
}

/**
 * 获取套券列表（用于发放内容选择）
 * @param {Object} query - 查询参数
 */
function getBonusRuleList(query) {
  return (0, _requestAuth.default)({
    url: '/bonusRule/list',
    method: 'get',
    params: query
  });
}

/**
 * 复制秒杀活动
 * @param {Number} id - 活动ID
 */
function copySecKill(id) {
  return (0, _requestAuth.default)({
    url: "/secKill/copy/".concat(id),
    method: 'post'
  });
}

// ===================== 秒杀订单（全部订单） =====================

/**
 * 获取秒杀订单列表（全部订单）
 * @param {Object} query - 查询参数
 */
function getSecKillOrderList(query) {
  return (0, _requestAuth.default)({
    url: '/secKill/orderPage',
    method: 'get',
    params: query
  });
}

/**
 * 导出秒杀订单（异步，返回JSON，结果到导出日志下载）
 * @param {Object} query - 查询参数
 */
function exportSecKillOrder(query) {
  return (0, _requestAuth.default)({
    url: '/secKill/orderExport',
    method: 'get',
    params: query
  });
}

// ===================== 秒杀退款订单 =====================

/**
 * 获取秒杀退款订单列表
 * @param {Object} query - 查询参数
 */
function getSecKillRefundList(query) {
  return (0, _requestAuth.default)({
    url: '/secKillRefund/page',
    method: 'get',
    params: query
  });
}

/**
 * 导出秒杀退款订单（异步，返回JSON，结果到导出日志下载）
 * @param {Object} query - 查询参数
 */
function exportSecKillRefund(query) {
  return (0, _requestAuth.default)({
    url: '/secKillRefund/export',
    method: 'get',
    params: query
  });
}

/**
 * 审核秒杀退款
 * @param {Object} data - 审核数据
 */
function auditSecKillRefund(data) {
  return (0, _requestAuth.default)({
    url: '/secKillRefund/audit',
    method: 'post',
    data: data
  });
}

/**
 * 确认秒杀退款
 * @param {Object} data - 确认数据
 */
function confirmSecKillRefund(data) {
  return (0, _requestAuth.default)({
    url: '/secKillRefund/confirm',
    method: 'post',
    data: data
  });
}

/**
 * 管理员直接退款（仅退款，不作废券）
 * @param {Object} data - { orderId, money }
 */
function directSecKillRefund(data) {
  return (0, _requestAuth.default)({
    url: '/secKillRefund/directRefund',
    method: 'post',
    data: data
  });
}

/**
 * 管理员全额退款（退券+退款）
 * @param {Object} data - { orderId }
 */
function fullSecKillRefund(data) {
  return (0, _requestAuth.default)({
    url: '/secKillRefund/fullRefund',
    method: 'post',
    data: data
  });
}